<script setup lang="ts">
import type { ICellRendererParams } from "ag-grid-community";
import UrgencyIndicator from "../../components/UrgencyIndicator.vue";

const props = defineProps<{
  params: ICellRendererParams & {
    onToggleDetail?: (rowKey: string) => void;
  };
}>();

function handleClick(event: Event): void {
  event.stopPropagation();
  const data = props.params.data as
    | { _isDetail?: boolean; rowKey?: string }
    | undefined;
  if (!data) return;
  if (data._isDetail) return;
  if (data.rowKey && props.params.onToggleDetail) {
    props.params.onToggleDetail(data.rowKey);
  }
}
</script>

<template>
  <div
    class="details-column-renderer"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter="handleClick"
  >
    <UrgencyIndicator :params="params" />
  </div>
</template>
